import React from 'react';

const Categories = () => (
  <div className="categories">
    <h2>Under Construction...</h2>
  </div>
);

export default Categories;
